import { aboveTypes } from 'pages/types'

export default function helperClickHandler(p: aboveTypes,
    setBtnClick: (arg: boolean) => void,
    handleAbove: (arg: aboveTypes) => void,
) {
    return (setBtnClick(true),
        setTimeout(() => {
            handleAbove(p)
            setBtnClick(false)
        }, 167))
}
